import { render, staticRenderFns } from "./optionalBreak.vue?vue&type=template&id=77e85a06&scoped=true"
import script from "./optionalBreak.vue?vue&type=script&lang=js"
export * from "./optionalBreak.vue?vue&type=script&lang=js"
import style0 from "./optionalBreak.vue?vue&type=style&index=0&id=77e85a06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e85a06",
  null
  
)

export default component.exports